import Login from "../../pages/login";
import IFWUsers from "../../pages/ifw-users";
import PlanInputs from "../../pages/plan-inputs";
import Presentation from "../../pages/presentation";
import Layout from "../layout";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "@progress/kendo-theme-material/dist/all.css";
import "./App.css";
import PlanOutput from "../../pages/plan-output";
import PresentationLayout2 from "../presentation-layout2";
import AccountMenuModal from "../account-menu-modal";
import {useSelector} from "react-redux";
import Settings from "../../pages/settings";
import PasswordChangeSuccessModal from "../password-change-success-modal";

function App() {

  const isAccountModalOpen = useSelector(state => state.dataStore.get("isAccountModalOpen"));
  const isPasswordSuccessModalOpen = useSelector(state => state.dataStore.get("isPasswordChangeSuccessModalOpen"));

  return (
    <div className="App">
      <Router>
        <Switch>
          <Route path={"/"} exact>
            <Login />
          </Route>
          <Route path={"/ifw-users/:tabIndex/:idIncomeUser?"} exact>
            <Layout>
              <IFWUsers />
            </Layout>
          </Route>
          <Route
            path={"/financial-professionals/:fpid/clients/:id/plan-inputs"}
            exact
          >
            <PresentationLayout2>
              <></>
              <PlanInputs setGoals={() => { }} setIsCalculated={() => { }} />
            </PresentationLayout2>
          </Route>
          <Route path={"/presentation/:clientId"} exact>
            <Presentation />
          </Route>
          <Route path={"/plan-output"} exact>
            <PlanOutput />
          </Route>
          <Route path={"/settings"}>
            <Layout>
              <Settings />
            </Layout>
          </Route>
        </Switch>
      </Router>
      {
        isAccountModalOpen && <AccountMenuModal />
      }
      {
        isPasswordSuccessModalOpen && <PasswordChangeSuccessModal />
      }
    </div>
  );
}

export default App;
